var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-full md_w-auto mt-2 mx-1 md_mt-0 md_mx-0" },
    [
      _c(
        "div",
        {
          staticClass:
            "flex items-center justify-between w-full leading-tight border-b border-brand-secondary-800 px-1 cursor-pointer pb-_5 md_pb-0 md_px-0 md_border-0 md_leading-loose md_cursor-default",
          on: {
            click: function($event) {
              _vm.open = !_vm.open
            },
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              _vm.open = !_vm.open
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "text-2xl text-brand md_text-base md_font-bold select-none"
            },
            [_vm._v(_vm._s(_vm.title))]
          ),
          _c("div", { staticClass: "text-3xl md_hidden font-archivo" }, [
            _vm.open
              ? _c(
                  "svg",
                  {
                    staticStyle: { width: "24px", height: "24px" },
                    attrs: { viewBox: "0 0 24 24" }
                  },
                  [
                    _c("path", {
                      staticClass: "text-brand-secondary-400 fill-current",
                      attrs: { d: "M19,13H5V11H19V13Z" }
                    })
                  ]
                )
              : _c(
                  "svg",
                  {
                    staticStyle: { width: "24px", height: "24px" },
                    attrs: { viewBox: "0 0 24 24" }
                  },
                  [
                    _c("path", {
                      staticClass: "text-brand-secondary-400 fill-current",
                      attrs: { d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" }
                    })
                  ]
                )
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "flex flex-col pt-1 overflow-hidden transition-250 transition-all md_pt-0",
          style: _vm.style
        },
        _vm._l(_vm.links, function(link) {
          return _c("footer-column-link", {
            key: link.uri,
            staticClass: "ml-1 text-2xl md_text-base md_ml-0",
            attrs: { link: link }
          })
        }),
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }